// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chartjs-tooltip{opacity:1;position:absolute;background:rgba(0,0,0,.7);color:#fff;border-radius:3px;-webkit-transition:all .2s ease;transition:all .2s ease;pointer-events:none;-webkit-transform:translate(-50%);transform:translate(-50%);white-space:nowrap}.chartjs-tooltip-key{display:inline-block;width:10px;height:10px;margin-right:6px}", ""]);
// Exports
module.exports = exports;
